import React, { Component } from 'react';
import { connect } from "react-redux";
import { RemoveUploadFile, SetUploadFileList } from '$Deposits/store/actions/DepositAction'
import UploadingModal from '$Deposits/Components/Components/UploadingModal'

class UploadFile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {

    }
    componentWillUnmount() {
        this.props.RemoveUploadFile()
    }

    toggleLoading() {
        this.setState({
            loading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    loading: false
                })
            }, 1500);
        })
    }


    render() {
        const {
            UploadFileList = [],
            RemoveUploadFile,
            SetUploadFileList,
            UploadFile,
            UploadFileErr,
            DepositOldBank,
            MethodsActive
        } = this.props
        return (
            <>
                <UploadingModal Loadingvisible={this.state.loading} loadText={'Đang Tải Tài Liệu'}/>
                <UploadFile
                    UploadFileList={UploadFileList}
                    UploadFileErr={UploadFileErr}
                    RemoveUploadFile={RemoveUploadFile}
                    SetUploadFileList={SetUploadFileList}
                    toggleLoading={this.toggleLoading.bind(this)}
                    DepositOldBank={DepositOldBank}
                    MethodsActive={MethodsActive}
                />
            </>
        );
    }
}

const mapStateToProps = state => ({
    UploadFileList: state.UploadFileList,
    UploadFileErr: state.UploadFileErr,
    MethodsActive: state.MethodsActive,
	DepositOldBank: state.DepositOldBank,
});
const mapDispatchToProps = {
    RemoveUploadFile: () => RemoveUploadFile(),
    SetUploadFileList: (data = {}, d = false) => SetUploadFileList(data, d)

};
export default connect(mapStateToProps, mapDispatchToProps)(UploadFile);
